import { CdpClient } from './cdp';
const wsURL = new URLSearchParams(location.search).get('ws');
if (!wsURL) {
    document.body.innerHTML = '<div class="err">❌ Add ?ws=&lt;devtools-ws&gt; to the URL</div>';
    throw new Error('Missing ?ws param');
}
const canvas = document.getElementById('view');
const ctx = canvas.getContext('2d');
let viewW = 0, viewH = 0;
function resize() {
    viewW = canvas.width = window.innerWidth;
    viewH = canvas.height = window.innerHeight;
    cdp.send('Emulation.setDeviceMetricsOverride', {
        width: viewW, height: viewH, deviceScaleFactor: 1, mobile: false,
    });
}
window.addEventListener('resize', resize);
const cdp = CdpClient.connect(wsURL);
cdp.onOpen(async () => {
    await Promise.all([
        cdp.send('Page.enable'),
        cdp.send('DOM.enable'),
    ]);
    resize();
    await cdp.send('Page.startScreencast', { format: 'jpeg', quality: 80 });
});
cdp.onEvent('Page.screencastFrame', ({ data, sessionId }) => {
    cdp.send('Page.screencastFrameAck', { sessionId });
    const img = new Image();
    img.onload = () => ctx.drawImage(img, 0, 0, viewW, viewH);
    img.src = `data:image/jpeg;base64,${data}`;
});
const mods = (e) => (e.altKey ? 1 : 0) | (e.ctrlKey ? 2 : 0) | (e.metaKey ? 4 : 0) | (e.shiftKey ? 8 : 0);
const btn = {
    0: 'left',
    1: 'middle',
    2: 'right',
};
const mouseEventMap = {
    mousedown: 'mousePressed',
    mouseup: 'mouseReleased',
    mousemove: 'mouseMoved',
};
['mousedown', 'mouseup', 'mousemove', 'wheel'].forEach(type => {
    canvas.addEventListener(type, evRaw => {
        const ev = evRaw;
        const base = {
            x: ev.offsetX,
            y: ev.offsetY,
            modifiers: mods(ev),
            clickCount: 1,
        };
        if (type === 'wheel') {
            cdp.send('Input.dispatchMouseEvent', {
                type: 'mouseWheel',
                button: 'none',
                deltaX: ev.deltaX,
                deltaY: ev.deltaY,
                ...base,
            });
        }
        else {
            cdp.send('Input.dispatchMouseEvent', {
                type: mouseEventMap[type],
                button: type === 'mousemove' ? 'none' : (btn[ev.button] || 'none'),
                ...base,
            });
        }
        ev.preventDefault();
        canvas.focus();
    }, { passive: false });
});
['keydown', 'keyup', 'keypress'].forEach(type => {
    document.addEventListener(type, eRaw => {
        const e = eRaw;
        let eventType;
        switch (type) {
            case 'keydown':
                eventType = 'keyDown';
                break;
            case 'keyup':
                eventType = 'keyUp';
                break;
            case 'keypress':
                eventType = 'char';
                break;
        }
        if (e.key === 'Backspace') {
            e.preventDefault();
        }
        const text = eventType === 'char' ? String.fromCharCode(e.charCode) : undefined;
        cdp.send('Input.dispatchKeyEvent', {
            type: eventType,
            text,
            unmodifiedText: text ?? undefined,
            key: e.key,
            code: e.code,
            keyIdentifier: e.keyIdentifier ?? undefined,
            windowsVirtualKeyCode: e.keyCode,
            nativeVirtualKeyCode: e.keyCode,
            autoRepeat: e.repeat,
            isKeypad: false,
            isSystemKey: false,
            modifiers: mods(e),
        });
    }, true);
});
